import loadScript from './loadScript';

const loadKustomerScript = () => {
  setTimeout(() => {
    loadScript({
      id: 'kustomer-chat-widget-script',
      attributes: {
        src: 'https://cdn.kustomerapp.com/chat-web/widget.js',
        'data-kustomer-api-key':
          'eyJhbGciOiJub25lIn0.eyJvcmciOiI2MDY3MTM5MWUxYzkxMmJmMDkxMTVmODIiLCJvcmdOYW1lIjoiam95YmlyZCIsInJvbGVzIjpbIm9yZy50cmFja2luZyJdfQ.',
      },
    });
  }, 3000);
};

export default loadKustomerScript;
